module.exports = __webpack_public_path__ + "static/img/postponedBadge.c6678738.png";